import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import { DataGrid } from '@mui/x-data-grid';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import Autocomplete from '@mui/material/Autocomplete';
import TableRow from "@mui/material/TableRow";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined"; // Acromegaly React components
import MDBox from "components/MDBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { useMaterialUIController } from "context";
import { NavLink, useNavigate, useParams,useSearchParams } from "react-router-dom";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Toolbar,
  Box,
  CssBaseline,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  useMediaQuery,
  Tooltip,
  Checkbox
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import TablePaginationActions from "examples/Tables/TablePaginationActions";
import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import {
  getCapsules,
  updateCapsuleRowNumbers,
  deleteCapsule,
  editCapsules,
} from "controllers/MenuController";
import { displaySuccessMessage } from "controllers/validation";
import { submitCapsule } from "controllers/MenuController";
import { getUsersList } from "controllers/UserController";
import { deleteUser } from "controllers/UserController";
import UserPermission from "../usres/UserPermission";
import { updateActiveState } from "controllers/UserController";
import Register from "../usres/Register";
import TreeSelect, {
  FreeSoloNode,
  DefaultOption,
  getDefaultOptionProps,
} from "mui-tree-select";
import { getAllTitleAndCapsules } from "controllers/MenuController";
import { getfileswithcapsule } from "controllers/FileController";
import { getFileAccessUser } from "controllers/MenuController";
import { storeFileAccessUser } from "controllers/MenuController";
import { Label } from "@mui/icons-material";
const localText = () => ({
  
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} سطر انتخاب شده`
      : `${count.toLocaleString()} سطر انتخاب شده`,
      footerTotalRows: 'مجموع سطرها:',
// Total visible row amount footer text
footerTotalVisibleRows: (visibleCount, totalCount) =>
`${visibleCount.toLocaleString()} از ${totalCount.toLocaleString()}`,
  // Used core components translation keys
  MuiTablePagination: { 
    labelRowsPerPage: "تعداد داده در صفحه",
    labelDisplayedRows: ({ from, to, count }) =>
      count !== -1 ? `${from} تا ${to} از ${count}` : "خالی"
  },
})



class Node {
  constructor(value) {
    this.value = value;
  }

  getParent(data) {
    const parent = ((data) => {
      console.log(1)
      if ("type" in this.value && this.value.type === "title" ) {
        return null;
      } else if ("type" in this.value && this.value.type === "clinick" ) {
        return (
          data ?
          data.find(({ id }) =>
        this.value.id.split(',')[1] === id
          ) : null
        );
      } else {
        return null;
      }
    })();
    return parent ? new Node(parent) : parent;
  }
  getChildren() {
    
      return this.value.children.map((ch) => new Node(ch));
    
  }
  isBranch() {
    return "type" in this.value && this.value.type === "title" ;
  }
  isEqual(to) {
    return to.value.id === this.value.id;
  }
  toString() {
    return this.value.name;
  }
}


const selectOptions = [{id:"select",name:'انتخاب از لیست'},{id:'range',name:'بازه‌ی عددی'}]
const accessOptions = [{id:"edit",name:"ویرایش"},{id:'result',name:'نتایج'}]
function FilesAccess(props) {
  const [capsules,setCapsules] = useState([]);
  const [capsule, setCapsule] = useState(null);
  const [users,setUsers] = useState([]);
  const [user,setUser] = useState(null);
  const [accessType,setAccessType] = useState(accessOptions[0])
  const [selectType,setSelectType] = useState(selectOptions[0])
  const [files,setFiles] = useState([]);
  const [selecetedFiles,setselectedFiles] = useState([]);
  const [range,setRanges] = useState("")
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [showCreatedFiles, setShowCreatedFiles] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [datas, setDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [openMode, setOpenMode] = useState("");
  const [text, setText] = useState("");
  const [mode, setMode] = useState("new");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const params = useParams();
  let [searchParams, setSearchParams] = useSearchParams();
  const {title} = params
  useEffect(() => {
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }

    getCapsulesWithTitle();
    getUsers()
    
    
  }, []);
  useEffect(() => {
    console.log(searchParams.get('nodeId'))
    if(searchParams.get('nodeId'))
    {
      const t = capsules.find(c=>c.id===searchParams.get('nodeId').split(",")[1])
      console.log(t)
      if(t && 'children' in t && t.children )
      {
        const capsule = t.children.find(ca=>ca.id === searchParams.get('nodeId'))
        console.log(capsule)
        if(capsule)
        setCapsule(new Node(capsule))
      }
    }
    if(searchParams.get('userId'))
    {
      const u = users.find(u=>u._id===searchParams.get('userId'))
      if(u)
      setUser(u)
    }
    
    
  }, [searchParams,capsules,users]);

  useEffect(() => {
    if(selectType.id === selectOptions[0].id)
    getFiles()
    getfileAccess()
  },[capsule,user,accessType])



  const getCapsulesWithTitle = async () => {
    setLoading(true);
    let result = await getAllTitleAndCapsules(controller.token);
    if (result.success) {
      let data = result.data;
      console.log("data.children[0]")
      console.log(data.children[0].children)
      setCapsules(data.children[0].children);
    } else {
      displayErrorMessage(result.message);
    }
    setLoading(false);
  };

  const getUsers = async (rowsPerPagex=-1, pagex=-1, searchx="") => {
    try {
      setLoading(true);
      let newData = {
        rowsPerPage: rowsPerPagex,
        page: pagex,
        search: searchx,
        lang: controller.lang,
      };

      let usersList = await getUsersList(newData, controller);
      setLoading(false);
      if (usersList.success) {
        console.log(usersList.data);
        setUsers(usersList.data);
      } else {
        displayErrorMessage(controller.lang, usersList.message, usersList.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };

  const getFiles = async ( search = "") => {
    try {
      console.log(capsule)
      if(capsule)
      {
        let newData = {
          capsule: capsule.value.id.split(',')[2],
          search,
          fileMenuType: 'capsule',
        };
        let res = await getfileswithcapsule(newData, controller);
        if (res.success) {
          setFiles(res.data);
        } 
      }
      
    } catch (err) {
      console.log(err);
      displayErrorMessage("fa");
    }
  };

  const getfileAccess = async () => {
    try {
      console.log(capsule)
      let newData={};
      console.log(capsule , user , accessType)
      if(capsule && user && accessType)
      {
        newData.capsule = capsule.value.id.split(',')[2]
        newData.user = user._id
        newData.permission = accessType.id
        let res = await getFileAccessUser(controller.lang,newData, controller.token);
        if (res.success) {
          const data = res.data;
          if(data)
          {
            if('showCreatedFiles' in data && data.showCreatedFiles)
              {
                setShowCreatedFiles(data.showCreatedFiles)  
              }
            setselectedFiles(data.files??[])
            if('range' in data && data.range)
            {
              setRanges(data.range)

            }
         
          if('selectType' in data && data.selectType)
          setSelectType(selectOptions.find(o=>o.id === data.selectType))
          } 
          else{
            setselectedFiles([])
            setRanges("")
          }
      }
    }
      
      
       
        
      
      
    } catch (err) {
      console.log(err);
      displayErrorMessage("fa");
    }
  };


  const navigate = useNavigate();
 
  const submitFiles = async () => {
    try{
      const newData ={
        user: user._id,
        capsule: capsule.value.id.split(',')[2],
        permission: accessType.id ,
        selectType: selectType.id,
        files: selecetedFiles,
        range: range,
        showCreatedFiles:showCreatedFiles
      }
      let res = await storeFileAccessUser(controller.lang,newData, controller.token);
      if (res.success) {
       
          Swal.fire({
          text: getText("insertsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } 
    
  } catch (err) {
    console.log(err);
    displayErrorMessage("fa");
  }
        

  }
  
  // const submitCapsuleHandler = async () => {
  //   let newCapsule = {};
  //   if (mode === "new") {
  //     newCapsule = {
  //       title: title,
  //       rownumber: count + 1,
  //       lang: controller.lang,
  //       text,
  //     };

  //     setLoading(true);
  //     let data = await submitCapsule(
  //       controller.lang,
  //       newCapsule,
  //       controller.token
  //     );
  //     if (data.success) {
  //       Swal.fire({
  //         text: getText("insertsuccesfully", controller.lang),
  //         position: "top-end",
  //         icon: "success",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       });
  //       handleClose();

  //       getData(rowsPerPage, page + 1, search);
  //     } else {
  //       if (data.errorCode === 101) {
  //         navigate("/authentication/sign-in", { replace: true });
  //       } else {
  //         console.log(data);
  //         displayErrorMessage(controller.lang, data.message, data.code);
  //       }
  //     }
  //   } else {
  //     newCapsule = {
  //       id: editId,
  //       title: title,
  //       lang: controller.lang,
  //       text,
  //     };
  //     let data = await editCapsules(
  //       controller.lang,
  //       newCapsule,
  //       controller.token
  //     );
  //     if (data.success) {
  //       Swal.fire({
  //         text: getText("editsuccesfully", controller.lang),
  //         position: "top-end",
  //         icon: "success",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       });
  //       handleClose();
  //       getData(rowsPerPage, page + 1, search);
  //     } else {
  //       if (data.errorCode === 101) {
  //         navigate("/authentication/sign-in", { replace: true });
  //       } else {
  //         displayErrorMessage(controller.lang, data.message, data.code);
  //       }
  //     }
  //   }

  //   setLoading(false);
  // };
  
 
  
  


  const columns = [
    { field: 'text', headerName: 'نام پرونده', width: 130,renderCell: (params) => {
      return <p style={{textAlign:"right"}}>{params.row.text}</p>
    } },
    { field: 'nationalCode', headerName: 'کد ملی', width: 130
   }
  ];
  const getChildrens =(node) =>
          
  node
    ? node.getChildren() : capsules.map((cap) => new Node(cap))
    
    const getParent = (node) => node.getParent(capsules)
  const isBranch = (node) => node.isBranch()

  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("filepermisions", controller.lang)}
        showserch={false}
      />
      <MDBox pb={3} >
        <Card>
          <MDBox>
            <LoadingOverlay
              active={loading}
              spinner
              text={getText("loading", controller.lang)}
            >
              
              <Box dir={'ltr'}>

          <div style={{display:"flex" ,flexWrap:"wrap"}}>
          <TreeSelect
         getChildren={getChildrens}
         getOptionDisabled={(option) => {
           var _a;
           return (
             option.isBranch() &&
             !((_a = option.getChildren()) === null || _a === void 0
               ? void 0
               : _a.length)
           );
         }}
         getParent={getParent}
         isBranch={isBranch}
         isOptionEqualToValue={(option, value) => {
           return option instanceof FreeSoloNode ? false : option.isEqual(value);
         }}
         renderInput={(params) => (
           <TextField
             {...params}
             label="کلینیک"
           />
         )}
         value={capsule}
         onChange={(_, value) => {setCapsule(value); console.log(value)}}
         sx={{ m: 1, mt: 2, mb: 2 ,width:"46%"}}

       />
           <Autocomplete
  disablePortal
  id="combo-box-demo"
  options={users}
  getOptionLabel={(option) => option.name}
  renderInput={(params) => <TextField {...params} label="کاربر"  />}
  value={user}
        onChange={(event, newValue) => {
          setUser(newValue);
        }}
  sx={{ m: 1, mt: 2, mb: 2 ,width:"46%"}}
  />
  <Autocomplete
  disablePortal
  id="combo-box-demo"
  options={accessOptions}
  getOptionLabel={(option) => option.name}
  renderInput={(params) => <TextField {...params} label="نوع دسترسی پذیری"  />}
  isOptionEqualToValue={(option, value) => {
          return option.id === value.id
        }}
  value={accessType}
        onChange={(event, newValue) => {
          setAccessType(newValue);
        }}
  sx={{ m: 1, mt: 2, mb: 2 ,width:"46%"}}
  />
  <Autocomplete
  disablePortal
  id="combo-box-demo"
  options={selectOptions}
  getOptionLabel={(option) => option.name}
  renderInput={(params) => <TextField {...params} label="نحوه انتخاب"  />}
  isOptionEqualToValue={(option, value) => {
          return option.id === value.id
        }}
  value={selectType}
        onChange={(event, newValue) => {
          setSelectType(newValue);
        }}
  sx={{ m: 1, mt: 2, mb: 2 ,width:"46%"}}
  />
          

  
          </div>
          </Box>

        

          {selectType.id === "select" ?<DataGrid
           sx={{ m: 1, mt: 2, mb: 2 ,width:"95%","& .MuiDataGrid-row:hover": {
            backgroundColor: "skyblue"
            
          }}}
        rows={files}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        disableColumnMenu
        pageSizeOptions={[10,50, 100]}
        checkboxSelection
        onRowSelectionModelChange={(newRowSelectionModel) => {
          
          setselectedFiles(newRowSelectionModel);
        }}
        rowSelectionModel={selecetedFiles}
        localeText={localText()}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
        }
      />:<></>}
      {selectType.id === "range" ?<div style={{display:"flex",margin:10}}>
      
      <TextField id="outlined-basic" label="بازه عددی" variant="outlined"  value={range} onChange={(e)=>{
        setRanges(e.target.value)
      }} />

    </div>:<></>}
    <Box>
    <FormControlLabel
    control={
      <Checkbox
            
      className={"clinickChb"}
      name="clinick"
      checked={showCreatedFiles}
      onChange={(e) => {
        setShowCreatedFiles(!showCreatedFiles)
      }}
    />
    }
    label = "نمایش پرونده های ایجاد شده توسط کاربر"
    />
   
    </Box>
    
        <Button  style={{color: 'white',margin:10 }} variant="contained" onClick={()=>submitFiles()}>ثبت دسترسی ها </Button>
            </LoadingOverlay>
          </MDBox>
        </Card>
      </MDBox>
      
  
    </DashboardLayout>
  );
}

export default FilesAccess;
